// extracted by mini-css-extract-plugin
export var audioPlayer = "_nr-0";